import { Box, collapseDrawerState, Divider } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import Skeleton from 'react-loading-skeleton';

const topWidths = [120, 180, 160, 80];
const bottomWidths = [140, 60, 180, 80, 120, 140, 140];

export const Loading = () => {
    const isDrawerCollapsed = useAtomValue(collapseDrawerState);

    return (
        <Box spacing='0 12' width='100%'>
            {topWidths.map((width, index) => (
                <Box key={`top-${index}`} height={40} spacing='12 0'>
                    <Skeleton width={isDrawerCollapsed ? '100%' : width} height={16} />
                </Box>
            ))}

            <Divider spacing='8 12' color='midnight50' />

            {bottomWidths.map((width, index) => (
                <Box key={`bottom-${index}`} height={40} spacing='12 0'>
                    <Skeleton width={isDrawerCollapsed ? '100%' : width} height={16} />
                </Box>
            ))}
        </Box>
    );
};
